import React from 'react';
import logo from '../../assets/nhs.svg';
import styles from './style.module.css';
import { NHSLogoText } from 'services/content';

const index = ({ showImage = false, text = 'continue' }) => {
  const buttonText = NHSLogoText[text];
  return (
    <button className={`${styles.nhsLogin_button} ${styles.nhsLogin_button_logo}`}>
      {showImage && (
        <div className={styles.button_logo}>
          <img data-testid='nhs-image' src={logo} alt="nhs logo" />
        </div>
      )}
      <span data-testid='nhs-text'>{buttonText}</span>
    </button>
  );
};

export default index;
